import { isHTMLContentEmpty } from "helpers/common";
import errorMessages from "utils/validation/errorMessages";
import { emailSchema, phoneRequiredSchema, select2RequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object, string } from 'yup';

const supportStaffAddSchema = object().shape({
	firstname: stringRequiredSchema,
	lastname: stringRequiredSchema,
	phone: phoneRequiredSchema,
	email: emailSchema,
	 

});

export default supportStaffAddSchema;